import {checkVAT, countries as vatIdValidators} from 'jsvat';

export const validateVatId = (countryCode, value) => {
	if (countryCode === 'DE') {
		return true;
	}
	const validator = vatIdValidators.find((v) => v.codes.find((c) => c === countryCode));
	if (!validator) {
		// "No validator found – skip validation";
		return true;
	}
	const result = checkVAT(value, [validator]);
	return result.isValid;
};
